import dateFormat from 'dateformat'
import toHiragana from 'jaco/lib/fn/toHiragana'
import toWideJapanese from 'jaco/lib/fn/toWideJapanese'
import toNarrowAlphanumeric from 'jaco/lib/fn/toNarrowAlphanumeric'
const ZipCodeJp = require('@/assets/lib/zip-code-jp')
const ZIP_CODE_BASE_URL = process.env.VUE_APP_ZIP_CODE_BASE_URL
const FormLib = {
  install: function (Vue, options) {
    Vue.prototype.$formLib = {
      zenToHanNumber: function (zenNumber) {
        return toNarrowAlphanumeric(zenNumber)
      },
      separatedPostNumber: function (postNumber) {
        if (postNumber) {
          return (
            postNumber.slice(0, 3) +
            '-' +
            postNumber.slice(3, postNumber.length)
          )
        }
      },
      addressFromZip: function (postNumber, callback) {
        if (!postNumber) {
          return
        }
        const lib = this
        postNumber = String(postNumber)
        ZipCodeJp.setZipCodeBaseUrl(ZIP_CODE_BASE_URL)
        ZipCodeJp.getAddressesOfZipCode(postNumber, function (err, addresses) {
          if (err) {
            console.error(err)
            return
          }
          if (typeof addresses[0] === 'undefined') {
            console.error('addresses[0] undefined')
            return
          }
          try {
            var addressesData = addresses[0]
          } catch (e) {
            console.error(e)
            return
          }
          const kanji = `${addressesData.prefecture_name}${addressesData.city_name}${addressesData.town_name}`
          const hkana = `${addressesData.prefecture_name_kana} ${addressesData.city_name_kana} ${addressesData.town_name_kana}`
          const callbackData = {
            addressesData,
            kanji,
            kana: lib.katakana2Hiragana(hkana)
          }
          callback(callbackData)
        })
      },
      katakana2Hiragana: function (text) {
        return toHiragana(toWideJapanese(text))
      },
      charCount: function (char) {
        if (typeof char !== 'string') {
          return 0
        }
        // 半角1、全角2で数える
        let len = 0
        let i
        char = char.replace(/[\n]+/g, '\n')
        char = escape(char)
        for (i = 0; i < char.length; i++, len++) {
          if (char.charAt(i) === '%') {
            if (char.charAt(++i) === 'u') {
              i += 3
              len++
            }
            i++
          }
        }
        return len
      },
      nextNumberInput: function ($event, $ref, maxLength) {
        if ($event.key === 'Enter') {
          $ref.focus()
        }
        if (!$event.target.value || isNaN(Number($event.key))) return
        if ($event.target.value.length >= maxLength) {
          if (!$ref) {
            console.error('$ref:', $ref, ' is not found')
            return
          }
          $ref.focus()
        }
      },
      nextInput: function ($ref) {
        if ($ref) {
          $ref.focus()
        } else {
          console.error('$ref:', $ref, ' is not found')
        }
      },
      calcAge: function (birthDate, targetDate) {
        const diff = new Date(targetDate.getTime() - birthDate.getTime())
        const result = Math.abs(diff.getUTCFullYear() - 1970)
        if (isNaN(result)) {
          return ' '
        }
        return result
      },
      dateWithoutTime: function (date) {
        if (!date) return
        try {
          date = new Date(date)
        } catch (e) {
          console.error(e, date)
          return
        }
        return dateFormat(date, 'yyyy-m-d')
      },
      getToday: function () {
        const today = new Date()
        return today
      },
      getTommorow: function () {
        const today = new Date()
        return today.setDate(today.getDate() + 1)
      },
      dateFormat: function (date, format = 'yyyy-m-d') {
        // https://github.com/felixge/node-dateformat
        if (!date) return
        // firestore TimeStamp
        if (typeof date.toDate !== 'undefined') {
          return dateFormat(date.toDate(), format)
        }
        let formatedDate
        try {
          formatedDate = dateFormat(date, format)
        } catch (e) {
          console.error(e, date)
          return '日付変換エラー'
        }
        return formatedDate
      },
      getJapaneseYear: function (year, month, day) {
        if (month > 12 || month < 1) {
          console.log('month is invalid:', month, ' set 1')
          month = 1
        }
        if (day > 31 || day < 1) {
          console.log('day is invalid:', day, ' set 1')
          day = 1
        }
        if (year < 1800 || year > 2118) {
          return {
            name: '',
            jYear: year,
            year
          }
        }
        const westernDate = new Date(year, month - 1, day, 0, 0, 0)
        const gengoList = [
          {
            name: '(新)', // 新しい元号が発表されたらここを変える
            endDate: new Date('2099/12/31 23:59:59'),
            diffYear: 2018
          },
          {
            name: '平成',
            endDate: new Date('2019/4/30 23:59:59'),
            diffYear: 1988
          },
          {
            name: '昭和',
            endDate: new Date('1989/1/7 23:59:59'),
            diffYear: 1925
          },
          {
            name: '大正',
            endDate: new Date('1926/12/24 23:59:59'),
            diffYear: 1911
          },
          {
            name: '明治',
            endDate: new Date('1912/7/29 23:59:59'),
            diffYear: 1867
          },
          {
            name: '明治以前',
            endDate: new Date('1868/1/24 23:59:59'),
            diffYear: 0
          }
        ]
        for (let i = 0; i < gengoList.length; i++) {
          if (westernDate.getTime() < gengoList[i].endDate.getTime()) {
            continue
          }
          if (!gengoList[i - 1]) {
            continue
          }
          const gengoItem = gengoList[i - 1]
          let jYear = year - gengoItem.diffYear
          if (jYear === 1) jYear = '元'
          return {
            name: gengoItem.name,
            jYear,
            year
          }
        }
        return {
          name: '',
          jYear: year,
          year
        }
      }
    }
  }
}
export default FormLib
